export default __webpack_public_path__ + "static/media/AdStorm_03.0dc9f605.png";